import { useState } from "react";
import ApiClient from "../../../methods/api/apiClient";
import loader from "../../../methods/loader";
import "./style.scss";
import Html from "./Html";
import { useNavigate } from "react-router-dom";
import formModel from "../../../models/form.model";
import { useDispatch, useSelector } from "react-redux";
import { login_success } from "../../../actions/user";
import { toast } from "react-toastify";

const EditProfile = ({ setEditTabSet }: any) => {
  const user = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const [form, setForm]: any = useState({
    firstName: user?.firstName || "",
    lastName: user?.lastName || "",
    email: user?.email || "",
    mobileNo: user?.mobileNo || "",
    id: user?.id || user?._id || "",
    image: user?.image || ""
  });
  const history = useNavigate();

  const handleSubmit = (e: any) => {
    e.preventDefault();
    let invalid = formModel.getFormError("profileForm");
    if (invalid) return;
    // if (!form?.image) { return }
    let value = {
      ...form,
    };
    loader(true);
    ApiClient.put("user/profile", value).then((res) => {
      if (res.success) {
        let data = { ...user, ...value, fullName: value?.firstName + " " + value?.lastName };
        dispatch(login_success(data));
        setEditTabSet(false)
      }
      loader(false);
    });
  };

  const ImageUpload = (e: any) => {
    let files = e.target.files
    let file = files.item(0)
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']; // Add more image types if needed
    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPG and PNG images are allowed.");
      return;
    }
    loader(true)
    ApiClient.postFormData('upload/image?model=user', { file: file }).then(res => {
      if (res.success) {
        setForm({ ...form, image: res?.data?.filePath })
      }
      loader(false)
    })
  }

  return (
    <>
      <Html
        handleSubmit={handleSubmit}
        setEditTabSet={setEditTabSet}
        setForm={setForm}
        form={form}
        ImageUpload={ImageUpload}
      />
    </>
  );
};

export default EditProfile;
